import { useState, useMemo, useCallback, useContext } from 'react';

//import { Crop } from './ColumnResizeProvider';

import HorizontalCropAdjuster from './HorizontalCropAdjuster';


export default function EndpointCropAdjustmentLayer({
  getHorizAdjustmentStartData,
  liveSide,
  ...props
}){

  return (
    <div style={{
      //border:'3px solid green',
      opacity:(liveSide?0:1),
      display:'flex',
      alignItems:'center',
    }} class="absolute-cover">
      {['left','right'].map(
        side => (
          <HorizontalCropAdjuster
            {...{
              ...props,
              height:15,
              side,
            }}
          />
        )
      )}
    </div>
  )

}
